import { render, staticRenderFns } from "./Roulette.vue?vue&type=template&id=59a6f642&scoped=true&"
import script from "./Roulette.vue?vue&type=script&lang=ts&"
export * from "./Roulette.vue?vue&type=script&lang=ts&"
import style0 from "./Roulette.vue?vue&type=style&index=0&id=59a6f642&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a6f642",
  null
  
)

export default component.exports